export const hasPubSelect = (salesProduct, Strategy) => {
  if (!salesProduct || !salesProduct.name) {
    return false;
  }
  //if (Strategy.name === 'AURA') {
  //  return 'AURA';
  //}
  if (Strategy.name === 'Aura TV Preroll') {
    return 'AURA_TV';
  }
  if (Strategy.name === 'Newsletter ROS Ads') {
    return 'N_ROS';
  }
  if (salesProduct.name === 'Custom') {
    return 'CUSTOM'
  }
  if (salesProduct.name === 'HDM YouTube') {
    return 'YT_HDM';
  }
  if (salesProduct.name === 'CDRT YouTube') {
    return 'YT_CDRT';
  }
  if (salesProduct.name.slice(0, 3) === 'HDM') {
    return 'HDM';
  }
  if (salesProduct.name.slice(0, 4) === 'CDRT') {
    return 'CDRT';
  }
  if (salesProduct.name === 'Automotive Consumer Targeting' || salesProduct.name === 'Predictive Intenders Package') {
    return 'HDM';
  }
  if (salesProduct.name === 'Hearst O&O Inventory') {
    return 'HOO';
  }
  return false;
};
